import { defineStore } from 'pinia'

export const useLayoutStore = defineStore('layout', {
    state: () => ({
        appBarHeight: 0 as number,
        filterRowHeight: 0 as number,
    }),
})
